export default {
	"ProductInfo.GrowBeans": "成长豆",
	"ProductInfo.SubscriptionUpgrade": "订阅升级"
}